import React, { useRef } from 'react';
import { Button, Row } from 'reactstrap';
import { faArrowLeft, faFileCsv, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSVLink } from 'react-csv';

//Context
import { useAuth } from '../../../../context/auth';
import moment from 'moment';
import CardRelatorio from '../components/CardRelatorio';
import { useReactToPrint } from 'react-to-print';
import { formatarPeriodo } from '../../../../helpers/formats';

//Estilo da pagina de impressão
const pageStyle = `
@media print {
  @page{
    size: A4;
    margin: 0.5rem;
  }

  body { 
    -webkit-print-color-adjust: exact; 
  } 

  .relatorio {
    width: 100vw !important;
    display:flex !important;
    flex-direction: column !important;
    padding: 0px 15px !important;
  }

  div.header{
    display:table-header-group;
  }

  div.body{
    display:table-row-group;
  }

  .noPrint{
    display: none;
  }
}
`;

function RelatorioDividaAtiva({ listaDividaAtiva = [], filtros, handleVoltar }) {
  const { session, logoSistema, logoSecretaria, logoPrefeitura } = useAuth();

  //Referencia do relatorio para download do csv
  const exportRef = useRef(null);

  //Referencia para o componente de impressão
  const ref = useRef(null);

  //headers da exportação do csv
  const headersExport = [
    { key: "numeroInfracao", label: "NÚMERO DO AUTO DE INFRAÇÃO" },
    { key: "numeroProcesso", label: "PROCESSO" },
    { key: "nomeInfrator", label: "NOME INFRATOR" },
    { key: "cpfCnpjInfrator", label: "CPF/CNPJ INFRATOR" },
    { key: "infracao_Identificacao", label: "IDENTIFICAÇÃO DA INFRAÇÃO" },
    { key: "valorMulta", label: "VALOR DA MULTA" },
    { key: "numeroPrimeiraGuia", label: "NÚMERO DA PRIMEIRA GUIA" },
    { key: "vencimentoPrimeiraGuia", label: "VENCIMENTO DA PRIMEIRA GUIA" },
    { key: "numeroUltimaGuia", label: "NÚMERO DA ÚLTIMA GUIA" },
    { key: "vencimentoUltimaGuia", label: "DATA DO VENCIMENTO" },
    { key: "valorJuros", label: "VALOR JUROS" },
    { key: "numeroProcessoSEI", label: "NÚMERO PROCESSO SEI" },
    { key: "dataNotificacao", label: "DATA DA NOTIFICAÇÃO" },
    { key: "anoExercicioMulta", label: "ANO DO EXERCÍCIO DA MULTA" },
    { key: "vencimentoPrimeiraGuia", label: "VENCIMENTO LEGAL" },
    { key: "valorMulta", label: "VALOR PRINCIPAL ORIGINAL" },
    { key: "localInfracao", label: "LOCAL DE INFRAÇÃO" },
    { key: "enderecoInfrator", label: "ENDEREÇO DO INFRATOR" },
    { key: "situacaoDividaAtiva", label: "SITUAÇÃO" },
  ];

  const headersDividaAtiva = [
    { objectValue: "numeroInfracao", value: "NÚMERO INFRAÇÃO", col: "12" },
    { objectValue: "numeroProcesso", value: "PROCESSO", col: "12" },
    { objectValue: "nomeInfrator", value: "NOME INFRATOR", col: "12" },
    { objectValue: "cpfCnpjInfrator", value: "CPF/CNPJ INFRATOR", col: "12" },
    { objectValue: "infracao_Identificacao", value: "IDENTIFICAÇÃO DA INFRAÇÃO", col: "12" },
    { objectValue: "valorMulta", value: "VALOR DA MULTA", col: "12" },
    { objectValue: "numeroPrimeiraGuia", value: " NÚMERO DA PRIMEIRA GUIA", col: "6" },
    { objectValue: "vencimentoPrimeiraGuia", value: "VENCIMENTO PRIMEIRA GUIA", col: "6" },
    { objectValue: "numeroUltimaGuia", value: " NÚMERO DA ÚLTIMA GUIA", col: "6" },
    { objectValue: "vencimentoUltimaGuia", value: "VENCIMENTO ÚLTIMA GUIA", col: "6" },
    { objectValue: "valorJuros", value: "VALOR JUROS ÚLTIMA GUIA", col: "6" },
    { objectValue: "numeroProcessoSEI", value: "NÚMERO PROCESSO SEI", col: "6" },
    { objectValue: "dataNotificacao", value: "DATA DA NOTIFICAÇÃO", col: "6" },
    { objectValue: "anoExercicioMulta", value: "ANO DO EXERCÍCIO DA MULTA", col: "6" },
    { objectValue: "vencimentoPrimeiraGuia", value: "VENCIMENTO LEGAL", col: "6" },
    { objectValue: "valorMulta", value: "VALOR PRINCIPAL ORIGINAL", col: "6" },
    { objectValue: "localInfracao", value: "LOCAL DE INFRAÇÃO", col: "6" },
    { objectValue: "enderecoInfrator", value: "ENDEREÇO DO INFRATOR", col: "6" },
    { objectValue: "situacaoDividaAtiva", value: "SITUAÇÃO", col: "6" },
  ];

  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => ref.current,
    documentTitle: "RelatorioDividaAtiva",
    pageStyle: pageStyle
  });

  return <>
    <div className='shadowFicha mainContainerFicha p-4'>
      <div className='d-flex align-items-center justify-content-between'>
        <Button color='secondary' className='text-white' onClick={handleVoltar}>
          <FontAwesomeIcon icon={faArrowLeft} />
          <span className='px-2'> Voltar </span>
        </Button>
        <div className='d-flex gap-2'>
          <Button color='danger' onClick={handlePrint}>
            <FontAwesomeIcon icon={faFilePdf} /> Imprimir
          </Button>
          <Button color='success' onClick={() => exportRef.current.link.click()}>
            <FontAwesomeIcon icon={faFileCsv} />
            <span className='px-2'> CSV </span>
          </Button>
        </div>
      </div>

      <CSVLink
        separator={";"}
        data={listaDividaAtiva}
        headers={headersExport}
        filename="Relatorio de Dívida Ativa.csv"
        target="_blank"
        ref={exportRef}
      />

      <div className="mt-4 relatorio w-100" ref={ref}>
        <div className="print m-2 d-flex align-items-center justify-content-between">
          <p>Emitido por: {session.nome}</p>
          <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
        </div>

        <div className='d-flex justify-content-between align-items-center w-100'>
          {logoSistema &&
            <div>
              <img src={logoSistema} width={180} alt="logo do sistema" />
            </div>
          }
          <div>
            {logoSecretaria && <img src={logoSecretaria} className='mt-3' width={140} alt="logo do sistema" />}
            {logoSecretaria && <img src={logoPrefeitura} width={120} alt="logo da prefeitura" />}
          </div>
        </div>

        <div className="header">
          <h5 style={{ color: "#666" }}>Relatório Dívida Ativa e CADIN</h5>
          <Row>
            <div className='col-12'>
              <p><span className="fw-bold">Período:</span> {formatarPeriodo(filtros.dataInicial, filtros.dataFinal)}</p>
            </div>
            <div className='col-6'>
              <p><span className="fw-bold">Tipo de Busca:</span> {filtros.tipoBusca}</p>
            </div>
            <div className='col-12'>
              <p><span className="fw-bold">Tipo de Fiscalização:</span> {filtros.tipoFiscalizacao_Descricao}</p>
            </div>
          </Row>
        </div>

        <div
          className='body'
          style={{ color: "#666" }}
        >
          <h5 className='rounded-3 bg-secondary text-light p-2'>Lista de Infrações</h5>
          <CardRelatorio
            headers={headersDividaAtiva}
            items={listaDividaAtiva}
          />
        </div>
      </div >
    </div>
  </>;
}

export default RelatorioDividaAtiva;